import { AnaliseDeRiscoCliente } from '../analise-de-risco-cliente.model';

export class UpdateArquivoAnaliseRiscoDTO {
  arquivoId: number;
  analises: AnaliseDeRiscoCliente[];
  action: string;
}
